export type Product = {
  /** Title-bar left: apt-style package name. */
  pkg: string;
  /** Title-bar right: platforms. */
  platform: string;
  /** Accent-colored kicker above the name. */
  kicker: string;
  name: string;
  copy: string;
  pills: readonly string[];
  url: string;
  /** Link label without the arrow, e.g. "jobmand.com". */
  linkLabel: string;
};

export const products: readonly Product[] = [
  {
    pkg: 'seaxdev-jobmand',
    platform: 'web · mobile',
    kicker: 'product · SaaS',
    name: 'Jobmand',
    copy: 'Construction and field-service management that runs every job from first call to final payment: estimates, e-signed contracts, projects, scheduling, time tracking and invoicing in one place.',
    pills: ['QR clock-in', 'budget vs actual', 'customer portal', 'EN · ES · PT'],
    url: 'https://www.jobmand.com/',
    linkLabel: 'jobmand.com',
  },
  {
    pkg: 'seaxdev-capepup',
    platform: 'iOS · watchOS',
    kicker: 'product · mobile app',
    name: 'Cape Pup',
    copy: 'The companion app for dog owners on Cape Cod: a Canine Passport for your dog, a live map of dog-friendly beaches, trails and cafés, and walk tracking on Apple Watch.',
    pills: ['Canine Passport', 'live map', 'Apple Watch walks'],
    url: 'https://www.capepup.com/',
    linkLabel: 'capepup.com',
  },
  {
    pkg: '~/portfolio/uplevel',
    platform: 'web design',
    kicker: 'design · client website',
    name: 'Uplevel Custom Cabinetry',
    copy: 'Website for a custom cabinetry maker in Hyannis, Cape Cod, showcasing bespoke kitchens, architectural built-ins and statement vanities.',
    pills: ['web design', 'portfolio site'],
    url: 'https://www.uplevelcabinetry.com/',
    linkLabel: 'uplevelcabinetry.com',
  },
];
